import { NextParsedUrlQuery } from 'next/dist/server/request-meta'

export const getQueryString = (query: NextParsedUrlQuery) => {
  const queryItems = Object.entries(query)
    .map(i => `${i[0]}=${i[1]}`)
    .join('&')
  return Object.entries(query).length > 0 ? `?${queryItems}` : ''
}
